var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-curso",style:(_vm.styles.cardCurso)},[_c('ImageLoader',{staticClass:"img",attrs:{"url":_vm.img},on:{"click":function($event){return _vm.$emit('click')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }